import { Injectable, enableProdMode } from '@angular/core';
import { HelpersService } from './helpers.service';

enableProdMode();

@Injectable({
  providedIn: 'root'
})
export class AauthService {

  currentPage: any;
  currentUserData: any;
  loggedUserHash: string;
  isLogged: any;
  responseData: any;
  redirectUrl: string;
  loginResultToast: object = {
    message: '',
    color:'warning',
    position: 'top',
    timeout: 5000,
  };
  // Variaveis a serem carrecadas do helperService
  private axios: any;
  private router: any;

 
  private modelService: any;
  private languageService: any;
  private environment: any;

  private apiBaseUrl: string;
  private apiRoutes: {};
  private apiRequestOptions: any;
  private moment: any;
  private menuController: any;


  constructor(
    private helpersService: HelpersService
  ) 
  { 
    // Carregar de helpersService
    this.axios             = this.helpersService.axios; 
    this.router            = this.helpersService.router;
    this.modelService      = this.helpersService.modelService;
    this.languageService   = this.helpersService.languageService;
    this.apiBaseUrl        = this.helpersService.environment.apiBaseUrl;
    this.apiRoutes         = this.helpersService.environment.apiRoutes;
    this.apiRequestOptions = this.helpersService.environment.requestOptions;
    this.environment      = this.helpersService.environment;
    this.moment           = this.helpersService.moment;
    this.environment      = this.helpersService.environment;
    this.menuController = this.helpersService.menuController;
    

    // Checar conexão com a internet
    // this.helpersService.networkCheck();
  } 
 

  /** 
    @Param <Any> form
    @Return Promise<Any>
  **/
  async login(form: any, loggedDefaultRoute: string, redirect: boolean = true): Promise<any> {

  // manobra pra sobreescrever o base url
    const apiBaseUrl = await this.modelService.get('apiBaseUrl');
    this.apiBaseUrl = (apiBaseUrl != null) ? apiBaseUrl : this.apiBaseUrl;
  // fim manobra sobreescrever base url
  
    const target      = this.apiBaseUrl + await this.apiRoutes['login'],
          platform    = await this.modelService.getRoot('platform'),
          device      = await this.modelService.getRoot('device');
    
    
    let button: any = null,
        data:   any = form;

    // Checar se form é um formulário html, caso seja criar um form data dele, caso não considerar form como um objeto
    if((typeof(data) == 'object' && data.tagName == 'FORM')) {
      
      button = data.querySelector('ion-button');
      
      // Exibir spinner no botão
      this.helpersService.spinnerShow(button);

      // Transformar data em formData
      data = new FormData(form);

      // Adicionar plataforma e dispositivo
      data.append('platform', platform.name);
      data.append('language', await this.modelService.getRoot('language'));

      if(device != null)  
        data.append('device', device);

    } else {
        // Adicionar plataforma e dispositivo
        data.platform = platform.name;
        data.language = await this.modelService.getRoot('language');

        if(device != null)  
            data.device = device;
    }


    // Iniciar a requisição
    try {
     
      await this.axios.post(target, data, this.apiRequestOptions)
        .then( async (response: any) => {
        
          this.responseData = response.data.content;

          // armazenar a mensagem da api
          this.loginResultToast['message'] = this.responseData.message;
       
          if(this.responseData.success == true) {
            
            const session: any = this.responseData.items;
            const currentUser = (session['userHash'] != null && session['userHash'].length > 5) ? session['userHash'] : JSON.parse(session['userId']);
          
            // Pegar os dados do usuário pra o primeiro nivel do dataBase
            const currentUserData = (session['userData'] != null) ? session['userData'] : null;
            delete(session['userData']);
           
            // Criar "banco de dados" para salvar com base no hash do usuario atual
            let dataBase: any = {
                  userData: currentUserData,
                  cdn:  session['systemCdn'] + '/public/uploads',
                  welcomeMessage:  this.responseData.message,
                  welcomeMessageShow: true,
                  session: session
              };
            
            const today = this.moment().format('YYYY-MM-DD');
            
            //////// AJUSTE EXCLUSIVO Teste de Fertilidade (FCOL)
                  
                  // verificar se ja existe base com dados pra o usuario
                  let userDatabase: any =  await this.modelService.getRoot(session['userHash']);

                  if(userDatabase !== null) {
                    // console.log('ja tem dados');
                    
                    // console.log(userDatabase);

                    const restore = Object.assign(userDatabase, dataBase);
                    dataBase = restore;
                    // console.log(dataBase);
                   
                  }
              
                  // Montar os dados para as menstruações o local storage
                  let menstruations =  session['menstruationsData'],
                      mentruationsByYear: any = {},
                      menstruationsData: any,
                      methodData: any = session['methodData'],
                      signatureData: any = session['signatureData'],
                      unitData: any = session['unitData'];
                  
                  if(menstruations != null && methodData != null) {
                      // Deletar foreach abaixo
                      // Object.values(menstruations).forEach((key, value) => {
                      //     const _this: any = key;

                      //     mentruationsByYear[_this.year] = _this.dates;
                      // });

                      menstruationsData = {
                          fiMens: methodData.fi_mens,
                          seMens: methodData.se_mens,
                          thMens: methodData.th_mens,
                          foMens: methodData.fo_mens,
                          items: menstruations,
                          // years :mentruationsByYear
                      };
                  }

                  // Armazenar dados da unidade (caso existam)
                  if(unitData != null)   dataBase.unitData = unitData;

                  if(signatureData != null)   dataBase.signatureData = signatureData;
                  // caso os metodos estejam vazios, forçar redirecionar para o cadastro das menstruações, caso contrarário joga para o calendário
                  // loggedDefaultRoute  = (methodData == null || menstruationsData == null) ? 'register/menstruations' : 'calendar/tabs/main';
                    loggedDefaultRoute = 'calendar/tabs/main'; // mudei pra jogar direto pra o calendario, se n tiver as menstruações ele joga pra tela do caradastro


                  // Armazerar os dados do metodo para o storage
                  dataBase.methodData = methodData;
                  dataBase.menstruationsData = menstruationsData;

                  // Remover methodData e menstruationsData de session
                  delete(session['methodData']);
                  delete(session['signatureData']);
                  delete(session['menstruationsData']);
            ///////// FIM EXCLUSIVO TF FCOL
              
            // Armazenar o email da ultima pessoa logada
            await this.modelService.setRoot('lastLoggedUsername', session['personData']['username']);
            
            await this.modelService.setRoot('logged', this.responseData.success);
            await this.modelService.setRoot('loggedUser', currentUser);
            await this.modelService.setRoot('loggedToken', session['userToken']); // token jwt
            await this.modelService.setRoot('loggedName', session['personData']['name']);
            await this.modelService.setRoot('loggedDate', today);
            await this.modelService.setRoot('loggedDefaultRoute', loggedDefaultRoute);
            await this.modelService.setRoot(currentUser, dataBase);


            // dropar a pagina inicial, será setada no logoff
            await this.modelService.drop('firstPage', true);

            
            // await this.modelService.entries(); // comentar essa linha
            
          } else {
            // const data = {
            //   title: await this.languageService.get('ATTENTION'),
            //   message:this.responseData.message || this.helpersService.messagesAdjust(this.responseData.messages),
            //   buttonText:  await this.languageService.get('TRY_AGAIN'),
            // };
            
            // return await this.helpersService.alertShow(data);
             this.helpersService.toastShow(this.loginResultToast)
          }
        })
        .catch((error: any) => {
            alert(error);
          this.responseData = this.errorHandle(error);

        })
      } catch (error) {
        
         this.responseData = this.errorHandle(error);
      }
    
    // Esconder o spinner do botão
    this.helpersService.spinnerHide(null, this.responseData.success);
    
    // Redirecionar ou retornar dados
    const loggedMessage = (this.environment.appMultilanguage == true) ? await this.languageService.get('LOGIN_WELCOME_MESSAGE') + await this.modelService.getRoot('loggedName') : this.modelService.get('welcomeMessage');
    
    return (redirect == true && this.responseData.success == true) ? await this.loggedRedirect(loggedMessage, loggedDefaultRoute) : this.responseData;
  }

  /*    
    @Return Promise<Any>
  */
  async loggedCheck(returnToLogin: boolean = true): Promise<any> {
    let isLoggedIn = await this.modelService.getRoot('logged'),
        currentPage: any = await this.helpersService.routeActiveGet();
     
    isLoggedIn = (isLoggedIn == null) ? false : isLoggedIn;

       
    if(isLoggedIn == true) {
      const loggedDate        = await this.modelService.getRoot('loggedDate'),
            loggedTimeInDays = this.moment(loggedDate).diff(this.moment(), 'day');

      if(loggedTimeInDays != 0) {
        return this.logout();
      }
      
      // pegar o hash do usuário atual
      this.loggedUserHash = await this.modelService.getRoot('loggedUser');

      // Gerar mensagem de boas vindas
      const message = (this.environment.appMultilanguage == true) ? await this.languageService.get('LOGIN_WELCOME_MESSAGE') + await this.modelService.getRoot('loggedName') : this.modelService.get('welcomeMessage'),
            loggedDefaultRoute =  await this.modelService.getRoot('loggedDefaultRoute');

      // Redirecionar para a rota padrão depois de logar
      await this.loggedRedirect(message, loggedDefaultRoute);

    } else {
      // Redirecionar para página de login (caso já não esteja nela)
      if((currentPage == 'login' || currentPage.indexOf('login')) && returnToLogin == true) {
        this.helpersService.routeNavigate('login', false, 'up', true, null);
        
      }
    }
            
    return isLoggedIn;
  }

  /**
   * função para redirecionar caso esteja logado
   * 
   * @param message <sring>
   * @param defaultRoute <string>
   */
  async loggedRedirect(message: string, defaultRoute: string) {
    const showMessage = await this.modelService.get('welcomeMessageShow'),
          currentPage: any = await this.helpersService.routeActiveGet();
 
    if(currentPage == 'login' || currentPage.indexOf('login') != -1) {
      await this.router.navigate([`/${defaultRoute}`]).then( async () => {
        
        // Habilitar o menu, remover na view se necessário
        this.menuController.enable(true); 

        // Exibir mensagem de bem vindo no primeiro acesso
        if(showMessage === true) {
         
          // Marcar messageWelcomeShow como false (previnir que seja exibido novamente)
          this.modelService.set('welcomeMessageShow', false);
          this.loginResultToast['message']  = message;
          this.loginResultToast['color']    = 'success';
          this.loginResultToast['position'] = 'bottom';
          this.loginResultToast['timeout']  = '4000';
          
          // this.helpersService.toastShow(this.loginResultToast);
          
        }
      });
    }
  }
  
  /**
   * Desloga um usuário no Sistema
   *
   * @return Promise<Any>
   * @author Demerson Carvalho
  */
  async logout(): Promise<any> {
        
    // this.modelService.remove('apiBaseUrl');
    // this.modelService.remove('session');
    // this.modelService.remove('logged');
    // this.modelService.remove('welcomeMessage');
    // this.modelService.remove('welcomeMessageShow');

    // Remover dados relacionados a sessão
    await this.modelService.drop('userData');

    await this.modelService.drop('session');
    await this.modelService.drop('signatureData');
    await this.modelService.drop('menstruationsData');
    await this.modelService.drop('notificationsData');


    await this.modelService.drop('calendarData');
    await this.modelService.drop('signatureData');  
    await this.modelService.drop('calendarData', true);
    await this.modelService.drop('signatureData', true);    

    await this.modelService.drop('unitData');
    await this.modelService.drop('unitData', true);
     
    // Aguardar remoção de todo o storage
    await this.modelService.truncate('logged', true);
    await this.modelService.truncate('loggedUser', true);
    await this.modelService.truncate('loggedToken', true); 
    await this.modelService.truncate('loggedName', true);
    await this.modelService.truncate('loggedDate', true);
    await this.modelService.truncate('loggedDefaultRoute', true);  

    // armazenar pra mostrar o tab de login primeiro
    await this.modelService.setRoot('firstPage', 'login');

    
    const cachedPages = document.querySelectorAll('.ion-page-hidden, app-tabs');
    
    cachedPages.forEach((page) => {
      if(page.tagName != 'app-login' && page.tagName != 'APP-LOGIN' )
          page.remove();
    });
    
    // await this.modelService.truncate('platform', true); 

    // Redirecionar para página de login e forçar remoção de páginas em cache
    // gambiarra pra tirar a pagina de assinatura de cache, primeiro ir para o perfil pra depois deslogar
   
    await this.router.navigate(['/']).then( async () => {
      
    });    
  
  }

  passwordRecover() { 
    alert('teste');
  }
  
  /** 
    * Tratar erros de requisição (funçao ajustada para o padrão de retorno do axis)
    * @Param  <object | any> Error
    * @Return <object> requestError 
    * @author Demerson Carvalho
  **/
  private async errorHandle(error: object | any): Promise<any> {
    const requestError: any = {};

     requestError['error']   = true;
     requestError['success'] = false;
     requestError['content'] = {
      'message': error.name +'<br />'+error.message,
      'config': error.config
    } 

    if (error.response)   requestError.content['response'] = error.response;
    if (error.request)  requestError.content['request'] = error.request;
    

    // Aguar o alerta com o erro
    await this.errorThrow(error.message);

    // Retornar os dados do erro para a requisição de origem
    return  requestError;
  }

  /**  
    * Exibir Alerta com mensagem de erro na requisição
    * @Param <Any> Message, <string> cardType = default (padrão)
    * @Return <Void>
    * @author Demerson Carvalho
  **/
  private async errorThrow(message: any): Promise<any> {
      
    const modalData: object = {
      buttonText:  (this.environment.appMultilanguage === true) ? await this.languageService.get('TRY_AGAIN') : 'Tentar novamente',
      message:     (this.environment.appMultilanguage === true) ? await this.languageService.get(message.replace(/\s+/g, '_').toUpperCase()) : message
    };
 
    await this.helpersService.alertShow(modalData);

    this.helpersService.spinnerHide();
  }
    
  // getAuthorizationToken() {
  //   const currentUser = JSON.parse(localStorage.getItem('currentUser'));
  //   return currentUser.token;
  // }
 
}
